export const timeline = {
  cloudCoverOptions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  cloudCover: 20,
  timelineTurboThreshold: 20000,
};
